// Lives outside main#async, so it's initialised once and survives page transitions.
// The prefilled message is built on click, so it always reflects the current page.
export const initChatWidget = () => {
  const widget = document.querySelector('.js-chat-widget')
  if (!widget) return

  const toggle = widget.querySelector('.js-chat-toggle')
  const panel = widget.querySelector('#chat-widget-panel')
  const time = widget.querySelector('.js-chat-time')
  const start = widget.querySelector('.js-chat-start')

  const setOpen = open => {
    widget.classList.toggle('is-open', open)
    toggle.setAttribute('aria-expanded', open)
    panel.setAttribute('aria-hidden', !open)
    if (open) updateTime()
  }

  const updateTime = () => {
    time.textContent = new Date().toLocaleTimeString('en-US', {
      timeZone: 'Europe/Amsterdam',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
  }

  const buildMessage = () => {
    const tour = document.querySelector('[data-chat-context]')
    return tour
      ? `Hi ${widget.dataset.name}, I have a question about the ${tour.dataset.chatContext} tour.`
      : `Hi ${widget.dataset.name}, I have a question about your tours.`
  }

  toggle.addEventListener('click', () => setOpen(!widget.classList.contains('is-open')))
  widget.querySelector('.js-chat-close').addEventListener('click', () => setOpen(false))

  start.addEventListener('click', () => {
    start.href = `https://wa.me/${widget.dataset.phone}?text=${encodeURIComponent(buildMessage())}`

    if (typeof gtag === 'function') {
      gtag('event', 'chat_whatsapp_click', { page_location: window.location.href })
    }

    setOpen(false)
  })

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') setOpen(false)
  })
}
